  // ============================================
        // 2. POWERFUL FEATURES 锚点切换
        // ============================================
        function switchHotspot(index) {
            // 1. 更新左侧锚点状态
            document.querySelectorAll('.hotspot-marker').forEach((marker, i) => {
                marker.classList.toggle('active', i === index);
            });

            // 2. 更新右侧大图
            document.querySelectorAll('.hotspot-display-img').forEach((img, i) => {
                img.classList.toggle('active', i === index);
            });

            // 3. 更新右侧信息条
            document.querySelectorAll('.hotspot-info').forEach((info, i) => {
                info.classList.toggle('active', i === index);
            });

            // 4. 更新移动端按钮
            document.querySelectorAll('.hotspot-mobile-btn').forEach((btn, i) => {
                btn.classList.toggle('active', i === index);
            });
        }

        // 自动轮播（可选，每 5 秒切换）
        let autoPlayIndex = 0;
        let autoPlayTimer = setInterval(() => {
    const total = document.querySelectorAll('.hotspot-marker').length;
    autoPlayIndex = (autoPlayIndex + 1) % total;
    switchHotspot(autoPlayIndex);
}, 5000);

        // 用户交互时暂停自动轮播
        document.querySelectorAll('.hotspot-marker, .hotspot-mobile-btn').forEach(el => {
            el.addEventListener('click', () => {
                clearInterval(autoPlayTimer);
                autoPlayIndex = parseInt(el.dataset.index || 0);
            });
        });

        // ============================================
        // 3. EXPLORE 轮播速度动态调整（可选）
        // ============================================
        // CSS animation 已经实现无缝循环，这里不需要额外 JS

        // ============================================
        // 其他 Tab & FAQ
        // ============================================
        function switchTab(btn, tabId) {
            const container = btn.closest('.tabs-container');
            container.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
            container.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
            btn.classList.add('active');
            document.getElementById('tab-' + tabId).classList.add('active');
        }
        function switchTab2(btn, tabId) {
            const container = btn.closest('.tabs-container').parentElement;
            container.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
            container.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
            btn.classList.add('active');
            document.getElementById('tab2-' + tabId).classList.add('active');
        }
        document.querySelectorAll('.faq-question').forEach(btn => {
            btn.addEventListener('click', () => {
                const item = btn.parentElement;
                const isOpen = item.classList.contains('open');
                document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
                if (!isOpen) item.classList.add('open');
            });
        });